import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import HomePage from "@/pages/HomePage";
import PackagePage from "@/pages/PackagePage";
import ThankYouPage from "@/pages/ThankYouPage";
import { useLenis } from "@/hooks/useLenis";

const Shell = () => {
  useLenis();
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/packages/labour-only" element={<PackagePage packageId="labour-only" />} />
        <Route
          path="/packages/complete-package"
          element={<PackagePage packageId="complete-package" />}
        />
        <Route path="/thank-you" element={<ThankYouPage />} />
      </Routes>
      <Footer />
      <StickyCTA />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
